import { createApiSlice } from "@common/common-slice/commonSlice";

import { CRUD_RESPONSE_STATUS } from "@routes";

const apiConfig = [
  {
    name: "createResponseStatus",
    method: "post",
    url: CRUD_RESPONSE_STATUS,
    stateKey: "message",
  },
  {
    name: "getResponseStatus",
    method: "get",
    url: CRUD_RESPONSE_STATUS,
    stateKey: "responseStatusData",
  },
  {
    name: "updateResponseStatus",
    method: "put",
    url: CRUD_RESPONSE_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteResponseStatus",
    method: "delete",
    url: CRUD_RESPONSE_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    responseStatusData: [],
    selectedData: {},
  },

  reducers: {
    rowSelect: (state, action) => {
      state.selectedData =
        action?.payload?.length > 0 ? action.payload[0] : {};
    },
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "responseStatus",
  apiConfig,
  customReducers
);

const responseStatusSlice = slice;
export default responseStatusSlice.reducer;

export const {
  createResponseStatus,
  getResponseStatus,
  updateResponseStatus,
  deleteResponseStatus,
} = thunks;

export const {
  rowSelect,
} = actions;